import React, { Component } from 'react';
import Form, {
    FormComponentProps
} from 'antd/lib/form';
import { Row } from 'antd'

import update from 'immutability-helper';

import AntWfDragComponent from "./AntWfDragComponent";
import { uimap, FieldBase, AntInputField } from "easyui-core";
import './AntWfForm.css';
// import "antd/dist/antd.css";
import { AntInput } from "../form/textfields/Ant-input";
import { AntTextarea } from "../form/textfields/Ant-textarea";
import { AntDatetimePick } from "../form/datetimepick/Ant-datetime";
import { AntTableForm } from "../table/anttable/Ant-table";
import { AntEditTableForm } from "../table/anttable/Ant-table-edit";

interface AntWfFormProps extends FormComponentProps {
    onSubmit?: (e) => {} | void,
    form: any,
    formLayout?: string
}

class AntWfDragFormInner extends Component<
    any, {
        formLayout: "horizontal" | "inline" | "vertical",
        fields: FieldBase<any>[],
    }> {

    formItems: any
    uimap: any
    constructor(props) {
        super(props);
        this.uimap = uimap
        this.state = {
            formLayout: "vertical",
            fields: props.fields
        }
        this.formItems = [
            AntInput,
            AntTextarea,
            AntDatetimePick,
            AntTableForm,
            AntEditTableForm
        ]
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    }

    moveField = (dragIndex, hoverIndex) => {
        // const { data } = this.state;
        const { fields } = this.state
        const dragField = fields[dragIndex];
        const newFields = update(this.state, {
            fields: {
                $splice: [[dragIndex, 1], [hoverIndex, 0, dragField]],
            },
        })
        this.setState(
            newFields
        );
    }

    addField = (fieldItem, addindex) => {
        // if (fieldItem.)
        let newField = new AntInputField({
            key: 'userName123',
            isHorizontal: false,
            span: 12,
            label: "名字add",
            required: true
        })
        const newFields = update(this.state, {
            fields: {
                $splice: [[addindex, 0, newField]],
            },
        })
        console.log("fields", newFields)
        this.setState(
            newFields
        );
    }

    render() {
        const formItems = this.state.fields.map((field, index) => (
            <AntWfDragComponent component={this.uimap.get(field.selector)} key={field.key} index={index}
                form={this.props.form} field={field} formLayout={this.state.formLayout} moveField={this.moveField}
                addField={this.addField}></AntWfDragComponent>
        ));
        return (

            <Form onSubmit={this.handleSubmit} layout={this.state.formLayout} className="login-form">
                <Row gutter={16}>
                    {formItems}
                </Row>
            </Form>

        )
    }
}
export const AntWfDragForm = Form.create<any>({ name: 'antWfForm' })(AntWfDragFormInner);